<template>
  <div class="profit-loss-table">
    <b-table-lite
      :aria-label="i18n('profitLoss.profitAndLoss')"
      borderless
      small
      :fields="[
        { key: 'key', thClass: 'd-none', tdClass: 'td-key' },
        { key: 'value', thClass: 'd-none', tdClass: 'td-value' }
      ]"
      :items="items"
      class="bg-transparent mb-0"
    >
      <template #cell(key)="data">
        <span class="label pr-5">{{ i18n(`profitLoss.${data.value}`) }}</span>
      </template>
      <template #cell(value)="data">
        <span :class="['value', data.item.valuePercent ? getTextColor(data.value) : null]">
          {{ data.value }} <span v-if="data.item.valuePercent">{{ data.item.valuePercent }}</span>
        </span>
      </template>
    </b-table-lite>
  </div>
</template>

<script>
export default {
  name: 'c-profit-loss-table',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    i18n(subkey, ns) {
      return this.$t(`${ns || 'white-label.widgets.holdings'}.${subkey}`);
    },
    getTextColor(val) {
      const v = parseFloat(val);
      return v === 0 ? '' : v > 0 ? 'text-positive' : 'text-negative';
    }
  }
};
</script>

<style lang="scss">
.profit-loss-table {
  table {
    .td-key,
    .td-value {
      padding: 0.2em !important;
      margin: 0;
      .label {
        color: $gray-100;
        white-space: nowrap;
      }
      .value {
        white-space: nowrap;
      }
    }
    .td-value {
      text-align: right;
    }
  }
}
</style>
